import { useEffect, useState } from "react";
import { IconButton } from "@shared/components/IconButton";
import { usePreviousReadingImage } from "../../hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { useValidationContext } from "../../context";

type Props = {
  imageUrl: string;
  previousReadingId: any;
};

function ImageCard({ imageUrl, previousReadingId }: Props) {
  const remoteUtilityId = useRemoteUtilityId();
  const { readingId } = useValidationContext();

  const [showPrevious, setShowPrevious] = useState(false);
  const [previousImageUrl, setPreviousImageUrl] = useState<string | null>(null);

  const { data } = usePreviousReadingImage({
    remoteUtilityId,
    readingId: previousReadingId,
    showPrevious,
  });

  const handleTogglePrevious = () => {
    setShowPrevious((prev) => !prev);
  };

  useEffect(() => {
    if (showPrevious && data?.readingImage) {
      setPreviousImageUrl(data.readingImage);
    }
  }, [showPrevious, data]);

  useEffect(() => {
    setShowPrevious(false);
    setPreviousImageUrl(null);
  }, [readingId]);

  return (
    <div className="bg-white rounded-md shadow-sm border w-full min-h-[32rem]">
      <div className="bg-muted mb-4 flex flex-col items-center p-2">
        <h4 className="text-sm font-semibold text-gray-700">Meter Image</h4>
        <IconButton
          label={showPrevious ? "Hide Previous" : "Show Previous"}
          variant="secondary"
          onClick={handleTogglePrevious}
          className="py-1"
        />
      </div>

      <img
        src={imageUrl}
        alt="Current reading image"
        className="object-contain w-full h-fit mb-4"
      />

      {showPrevious && (
        <div className="px-2">
          <h5 className="text-xs text-gray-500 font-medium mb-1">
            Previous Reading Image
          </h5>
          {previousImageUrl ? (
            <img
              src={previousImageUrl}
              alt="Previous reading image"
              className="object-contain w-full h-fit"
            />
          ) : (
            <p>Previous reading not available</p>
          )}
        </div>
      )}
    </div>
  );
}

export default ImageCard;
